
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("list/tasklist_list_item",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <emoji style=\"color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"emojiValid") : depth0), depth0)) != null ? stack1 : "")
    + "</emoji> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon style=\"color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"iconsimple") : depth0), depth0)) != null ? stack1 : "")
    + "</icon> ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.defaultlist",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":392},"end":{"line":1,"column":426}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon style=\"font-size:inherit\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_lock_open",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":483},"end":{"line":1,"column":509}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"sharedToAll") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":1,"column":517},"end":{"line":1,"column":618}}})) != null ? stack1 : "")
    + " ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.sharedtoall",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":537},"end":{"line":1,"column":571}}})) != null ? stack1 : "")
    + " ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.shared",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":581},"end":{"line":1,"column":610}}})) != null ? stack1 : "")
    + " ";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon style=\"font-size:inherit\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_lock",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":660},"end":{"line":1,"column":681}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.private",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":689},"end":{"line":1,"column":719}}})) != null ? stack1 : "")
    + " ";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <i style=\"display:inline-block;width:24px;height:24px;line-height:24px;font-size:16px;color:#fff;background-color:rgba(200,200,200,0.5);text-align:center;border-radius:50%\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"ongoing") : depth0)) != null ? lookupProperty(stack1,"length") : stack1), depth0)) != null ? stack1 : "")
    + "</i> ";
},"16":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon style=\"display:inline-block;width:24px;height:24px;line-height:24px;font-size:16px;color:#fff;background-color:#6CB100;text-align:center;border-radius:50%\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"list.ic_completed_list","white",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":1139},"end":{"line":1,"column":1183}}}))
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexrow data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" class=\"border-pane fw-tasklist-header fw-tasklist-type-"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"taskListType") : depth0), depth0))
    + "\" data-fw-onclick=\"controllerselect\" style=\"height:64px\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"emojiValid") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":171},"end":{"line":1,"column":324}}})) != null ? stack1 : "")
    + " <flexauto><line>"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</line><line class=\"sub4\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"system") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":378},"end":{"line":1,"column":433}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isShared") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":1,"column":434},"end":{"line":1,"column":727}}})) != null ? stack1 : "")
    + " </line></flexauto> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"ongoing") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":1,"column":747},"end":{"line":1,"column":1198}}})) != null ? stack1 : "")
    + " </flexrow> ";
},"useData":true});
export default TPL;